(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["v02-sticky-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('v02-sticky-cart')) {
  customElements.define('v02-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-sticky-button]');
      this.label = this.querySelector('[data-sticky-label]');
      this.price = this.querySelector('[data-sticky-price]');
      this.error = this.querySelector('[data-sticky-error]');
      this.productInfo = this.closest('product-info');
      this.header = document.querySelector('.section-header');
      this.controller = new AbortController();
      this.refresh = () => this.sync();
      const source = this.productInfo?.querySelector('.product__info-container');
      if (!source) return;
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(source, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden', 'value'] });
      source.addEventListener('change', this.refresh, { signal: this.controller.signal });
      this.button.addEventListener('click', (event) => {
        this.sync();
        if (this.button.disabled) event.preventDefault();
      }, { signal: this.controller.signal });
      this.resizeObserver = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--v02-cart-height', `${this.getBoundingClientRect().height}px`);
      });
      this.resizeObserver.observe(this);
      if (this.header) {
        this.headerObserver = new ResizeObserver(() => this.observePrimary());
        this.headerObserver.observe(this.header);
      }
      this.sync();
    }
    setPrimaryVisible(visible) {
      this.toggleAttribute('data-primary-visible', visible);
      this.inert = visible;
    }
    observePrimary() {
      this.visibilityObserver?.disconnect();
      if (this.dataset.behavior === 'always') { this.setPrimaryVisible(false); return; }
      if (!this.primary) { this.setPrimaryVisible(true); return; }
      const headerHeight = Math.ceil(this.header?.getBoundingClientRect().height || 0);
      const rect = this.primary.getBoundingClientRect();
      this.setPrimaryVisible(rect.bottom > headerHeight && rect.top < window.innerHeight);
      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        this.setPrimaryVisible(entry.isIntersecting);
      }, { rootMargin: `-${headerHeight}px 0px 0px 0px`, threshold: 0 });
      this.visibilityObserver.observe(this.primary);
    }
    sync() {
      const primary = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
      if (this.primary !== primary) {
        this.primary = primary;
        this.observePrimary();
      }
      if (!primary) { this.button.disabled = true; return; }
      const busy = primary.classList.contains('loading');
      this.button.disabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true' || busy;
      this.button.setAttribute('aria-busy', String(busy));
      const label = busy ? this.dataset.adding : primary.querySelector('span')?.textContent.trim();
      if (label && this.label.textContent !== label) this.label.textContent = label;
      const priceContainer = document.getElementById(`price-${this.dataset.sectionId}`);
      const priceRoot = priceContainer?.querySelector('.price');
      const priceSelector = priceRoot?.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular';
      const price = priceContainer?.querySelector(priceSelector)?.textContent.trim();
      this.price.hidden = priceContainer?.classList.contains('hidden') || false;
      if (price && this.price.textContent !== price) this.price.textContent = price;
      const errorWrapper = this.productInfo.querySelector('.product-form__error-message-wrapper');
      const error = errorWrapper && !errorWrapper.hidden ? errorWrapper.querySelector('.product-form__error-message')?.textContent.trim() : '';
      this.error.hidden = !error;
      if (this.error.textContent !== (error || '')) this.error.textContent = error || '';
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.headerObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.controller?.abort();
      if (!document.querySelector('v02-sticky-cart')) document.documentElement.style.removeProperty('--v02-cart-height');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
